import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import API from '../api/axios';

const FALLBACK_MENUS = [
 { id: 1, parent_id: 0, sort_order: 1, title: 'Home', slug: 'home', url: '/', target: '_self' },
 { id: 2, parent_id: 0, sort_order: 2, title: 'About St. Andrews Group', slug: 'about-standrews-group', url: '/about-standrews-group', target: '_self' },
 { id: 28, parent_id: 2, sort_order: 1, title: 'About Gurugram Campus', slug: 'about-gurugram-campus', url: '/about-gurugram-campus', target: '_self' },
 { id: 22, parent_id: 2, sort_order: 1, title: 'Principal Message', slug: 'principal-message', url: '/principal-message', target: '_self' },
 { id: 23, parent_id: 2, sort_order: 2, title: 'Core Values', slug: 'core-values', url: '/core-values', target: '_self' },
 { id: 24, parent_id: 2, sort_order: 3, title: 'Our Philosophy', slug: 'our-philosophy', url: '/our-philosophy', target: '_self' },
 { id: 25, parent_id: 2, sort_order: 4, title: 'Recognition', slug: 'recognition', url: '/recognition', target: '_self' },
 { id: 27, parent_id: 2, sort_order: 6, title: 'Infrastructure', slug: 'infrastructure', url: '/infrastructure', target: '_self' },
 { id: 26, parent_id: 2, sort_order: 5, title: 'Our Schools', slug: 'our-schools', url: '/our-schools', target: '_self' },
 { id: 3, parent_id: 0, sort_order: 3, title: 'Academics', slug: 'academics', url: '/academics', target: '_self' },
 { id: 301, parent_id: 3, sort_order: 1, title: 'Student Corner', slug: 'student-corner', url: '/student-corner', target: '_self' },
 { id: 303, parent_id: 301, sort_order: 1, title: 'Beyond Classroom', slug: 'beyond-classroom', url: '/beyond-classroom', target: '_self' },
 { id: 304, parent_id: 301, sort_order: 2, title: 'Other Facilities', slug: 'other-facilities', url: '/other-facilities', target: '_self' },
 { id: 305, parent_id: 301, sort_order: 3, title: 'Gallery', slug: 'gallery', url: '/gallery', target: '_self' },
 { id: 306, parent_id: 3, sort_order: 2, title: 'Accreditation', slug: 'accreditation', url: '/accreditation', target: '_self' },
 { id: 307, parent_id: 3, sort_order: 3, title: 'Curriculum', slug: 'curriculum', url: '/curriculum', target: '_self' },
 { id: 317, parent_id: 3, sort_order: 3.5, title: 'Infrastructure', slug: 'infrastructure', url: '/infrastructure', target: '_self' },
 { id: 308, parent_id: 3, sort_order: 4, title: 'Our Programmes', slug: 'our-programmes', url: '/our-programmes', target: '_self' },
 { id: 309, parent_id: 3, sort_order: 5, title: 'CBSE Board', slug: 'cbse-board', url: '/cbse-board', target: '_self' },
 { id: 310, parent_id: 3, sort_order: 6, title: 'Exposure to Programming and Coding Languages', slug: 'exposure-to-programming-and-coding-languages', url: '/exposure-to-programming-and-coding-languages', target: '_self' },
 { id: 311, parent_id: 3, sort_order: 7, title: 'Extra-Curricular Activities', slug: 'extra-curricular-activities', url: '/extra-curricular-activities', target: '_self' },
 { id: 312, parent_id: 3, sort_order: 8, title: 'Why Us', slug: 'why-us', url: '/why-us', target: '_self' },
 { id: 313, parent_id: 308, sort_order: 1, title: 'Junior School Programme', slug: 'junior-school-programme', url: '/junior-school-programme', target: '_self' },
 { id: 314, parent_id: 308, sort_order: 2, title: 'Middle School Programme', slug: 'middle-school-programme', url: '/middle-school-programme', target: '_self' },
 { id: 315, parent_id: 308, sort_order: 3, title: 'Senior School Programme', slug: 'senior-school-programme', url: '/senior-school-programme', target: '_self' },
 { id: 4, parent_id: 0, sort_order: 4, title: 'Admission', slug: 'admission', url: '/admission', target: '_self' },
 { id: 42, parent_id: 4, sort_order: 0, title: 'Admission Guidelines', slug: 'admission-guidelines', url: '/admission-guidelines', target: '_self' },
 { id: 41, parent_id: 4, sort_order: 1, title: 'Fee Structure ( 2027-28)', slug: 'fees', url: '/fees', target: '_self' },
 { id: 5, parent_id: 0, sort_order: 5, title: 'Facilities', slug: 'facilities', url: '/facilities', target: '_self' },
 { id: 6, parent_id: 0, sort_order: 6, title: 'Gallery', slug: 'gallery', url: '/gallery', target: '_self' },
 { id: 7, parent_id: 0, sort_order: 7, title: 'Events', slug: 'events', url: '/events', target: '_self' },
 { id: 8, parent_id: 0, sort_order: 8, title: 'News', slug: 'news', url: '/news', target: '_self' },
 { id: 9, parent_id: 0, sort_order: 9, title: 'Contact', slug: 'contact', url: '/contact', target: '_self' },
];

const SCHOOLS = [
 { name: 'Gurugram', url: 'https://www.sawsgurugram.com/' },
 { name: 'Vasundhara', url: 'https://sawsvasundhara.com/' },
 { name: 'Indirapuram', url: 'https://www.sawsindirapuram.com/' },
 { name: 'Dehradun', url: 'https://www.sawsdehradun.in/' },
 { name: 'Siddharth Vihar', url: 'https://sawssiddharthvihar.in/' },
 { name: 'Sonipat', url: 'https://www.sawssonipat.com/' },
];

export const openMerritoPopup = (e) => {
  if(e) e.preventDefault();
  const btn = document.querySelector('.npfWidgetButton.npfWidget-19e823c49278038002c6e0e30ce39f61');
  if (btn) btn.click();
};

const Header = () => {
 const [menuOpen, setMenuOpen] = useState(false);
 const [openSubMenus, setOpenSubMenus] = useState({});
 const [menus, setMenus] = useState([]);
 const [settings, setSettings] = useState({});
 const [isMobile, setIsMobile] = useState(false);
 const [schoolOpen, setSchoolOpen] = useState(false);
 const [isVideoOpen, setIsVideoOpen] = useState(false);
 const schoolRef = useRef(null);
 const location = useLocation();

 useEffect(() => {
 const mq = window.matchMedia('(max-width: 1023px)');
 setIsMobile(mq.matches);
 const handler = (e) => setIsMobile(e.matches);
 mq.addEventListener('change', handler);
 

  return () => mq.removeEventListener('change', handler);
 }, []);

 useEffect(() => {
 const fetchData = async () => {
 try {
 const [menuRes, settingRes, contactRes] = await Promise.all([
 API.get('/menus/public'),
 API.get('/settings/public'),
 API.get('/contacts/public'),
 ]);
 setMenus(menuRes.data.data || []);
 const s = settingRes.data.data || {};
 const c = contactRes.data.data || {};
 setSettings({ ...s, ...c });
 } catch (err) { console.error(err); }
 };
 fetchData();
 }, []);

 useEffect(() => {
 const handleClickOutside = (e) => {
 if (schoolRef.current && !schoolRef.current.contains(e.target)) setSchoolOpen(false);
 };
 document.addEventListener('mousedown', handleClickOutside);
 

  return () => document.removeEventListener('mousedown', handleClickOutside);
 }, []);

 useEffect(() => {
 if (!menuOpen) setOpenSubMenus({});
 }, [menuOpen]);

 useEffect(() => {
 setOpenSubMenus({});
 }, [location.pathname]);

 const isActive = (slug) => {
 const path = location.pathname;
 if (slug === 'home' && path === '/') return true;
 return path === `/${slug}` || path.startsWith(`/${slug}/`);
 };

 const effectiveMenus = menus.length ? menus : FALLBACK_MENUS;
 const topMenus = effectiveMenus.filter(m => m.parent_id === 0).sort((a, b) => a.sort_order - b.sort_order);

 const getChildren = (parentId) =>
 effectiveMenus.filter(m => m.parent_id === parentId).sort((a, b) => a.sort_order - b.sort_order);

 const toggleSubMenu = (id, force) => {
 setOpenSubMenus(prev => ({ ...prev, [id]: force !== undefined ? force : !prev[id] }));
 };

 const renderMenu = (items, depth = 0, parentId = null) => (
 <ul className={
 depth === 0
 ? 'flex flex-col lg:flex-row lg:items-center lg:justify-center'
 : depth === 1
 ? 'lg:absolute lg:left-0 lg:top-full bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu' +
 (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
 : 'lg:absolute lg:left-full lg:top-0 bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu' +
 (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
 }
 >
 {items.map(menu => {
 const children = getChildren(menu.id);
 const hasChildren = children.length > 0;
 

  return (
 <li key={menu.id} className="relative"
 onMouseEnter={() => { if (hasChildren) toggleSubMenu(menu.id, true); }}
 onMouseLeave={() => { if (hasChildren) toggleSubMenu(menu.id, false); }}
 >
 <div className="flex items-center justify-between">
 <Link to={menu.url}
 className={`flex-1 block px-4 py-3 text-white text-[15px] capitalize font-semibold hover:bg-white/10 transition-colors ${isActive(menu.slug) ? 'bg-white/10' : ''}`}
 onClick={() => { if (!hasChildren) setMenuOpen(false); }}
 target={menu.target}>
 {menu.title}
 </Link>
 {hasChildren && (

 <button
 onClick={(e) => { e.preventDefault(); toggleSubMenu(menu.id); }}
 className={`px-3 py-2.5 text-white/60 hover:text-white hover:bg-white/10 transition-colors text-[15px] lg:hidden`}
 aria-label="Toggle Submenu"
 >
 <i className={`fas fa-chevron-${openSubMenus[menu.id] ? 'up' : 'down'}`}></i>
 </button>
 )}
 </div>
 {hasChildren && renderMenu(children, depth + 1, menu.id)}
 </li>
 );
 })}
 </ul>
 );

 

  return (
 <>
 {/* Top Bar */}
 <div className="bg-[#1b3160] text-white/80 py-2 text-[12px] sm:text-[13px] relative z-[60]">
 <div className="container max-w-full flex items-center justify-between px-2 md:px-8">
 
 {/* Left: Contact Icons */}
 <div className="flex items-center gap-3 md:gap-6">
 <div className="flex items-center gap-2">
 <a href="tel:+919643813920" className="hover:text-white transition-colors">
 <i className="fas fa-phone"></i>
 </a>
 <div className="hidden md:flex items-center gap-1">
 {settings.phone ? (
 settings.phone.split(/[,|]/).map((phone, i) => (
 <React.Fragment key={i}>
 <a href={`tel:+91${phone.trim()}`} className="hover:text-white transition-colors">
 +91-{phone.trim()}
 </a>
 {i < (settings.phone.split(/[,|]/).length - 1) && <span className="text-white/50">|</span>}
 </React.Fragment>
 ))
 ) : (
 <>
 <a href="tel:+919643813920" className="hover:text-white transition-colors">+91-9643813920</a>
 <span className="text-white/50">|</span>
 <a href="tel:+919643813921" className="hover:text-white transition-colors">+91-9643813921</a>
 </>
 )}
 </div>
 </div>
 
 <div className="hidden md:block text-white/50">|</div>
 
 <div className="flex items-center gap-2">
 <a href={`mailto:${settings.email || 'admissions@sawsgurugram.com'}`} className="hover:text-white transition-colors">
 <i className="fas fa-envelope"></i>
 </a>
 <a href={`mailto:${settings.email || 'admissions@sawsgurugram.com'}`} className="hidden md:block hover:text-white transition-colors">
 {settings.email || 'admissions@sawsgurugram.com'}
 </a>
 </div>
 </div>
 
 {/* Right: Socials, Newsletter, Schools */}
 <div className="flex items-center gap-3 md:gap-4">
 <a href={settings.facebook || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-facebook-f"></i></a>
 <a href={settings.instagram || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-instagram"></i></a>
 <a href={settings.youtube || '#'} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors"><i className="fab fa-youtube"></i></a>
 
 <a href="/newsletter.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:text-white transition-colors ml-1 md:ml-2">
 <i className="fas fa-file-pdf"></i> Newsletter
 </a>
 
 <div className="relative ml-1 md:ml-2" ref={schoolRef}>
 <button onClick={() => setSchoolOpen(!schoolOpen)} className="flex items-center gap-1 hover:text-white focus:outline-none transition-colors">
 Our Schools <i className={`fas fa-chevron-${schoolOpen ? 'up' : 'down'} text-[10px]`}></i>
 </button>
 {schoolOpen && (
 <div className="absolute top-full right-0 mt-2 w-48 sm:w-56 bg-white rounded shadow-xl border border-gray-100 py-2 overflow-hidden z-50 text-gray-800">
 {SCHOOLS.map(s => (
 <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="block px-4 py-2 hover:bg-gray-50 transition-colors">
 {s.name}
 </a>
 ))}
 </div>
 )}
 </div>
 </div>
 
 </div>
 </div>

 {/* Main Header */}
 <header className="bg-white sticky top-0 z-50 shadow-sm transition-all duration-300">
 <div className="container max-w-full px-4 md:px-8 py-2 md:py-3">
 <div className="flex items-center justify-between">
 
 {/* Logos (Left) */}
 <div className="flex items-center gap-3 sm:gap-5">
 <Link to="/" className="flex-shrink-0 relative group" onClick={() => setMenuOpen(false)}>
 <img src={settings.logo ? `${settings.logo}` : '/images/logo/logo-main.webp'} alt="St. Andrews World School" className="h-12 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
 </Link>

 {/* Vertical Divider */}
 <div className="hidden sm:block h-10 w-[2px] bg-gray-200"></div>

 {/* Cambridge Logo */}
 <div className="hidden sm:flex items-center">
 <img src="/images/cambridge-knowledge-partner.jpg" alt="Cambridge Assessment" className="h-10 md:h-14 object-contain" onError={(e) => e.target.style.display = 'none'} />
 </div>
 </div>
 
 {/* Buttons (Right) */}
 <div className="hidden lg:flex items-center gap-4">
 <button onClick={openMerritoPopup} className="px-6 py-2 bg-[#1b3160] text-white rounded-full font-semibold text-[15px] hover:bg-opacity-90 transition flex items-center gap-2 cursor-pointer">
              Apply Now <i className="fas fa-arrow-right text-[13px]"></i>
            </button>
 <button onClick={() => setIsVideoOpen(true)} className="px-6 py-2 border border-[#1b3160] text-[#1b3160] bg-white rounded-full font-semibold text-[15px] hover:bg-gray-50 transition cursor-pointer">
 Our Campus Tour
 </button>
 </div>

 <button className="lg:hidden bg-[#1b3160] text-white px-4 py-2 rounded-md focus:outline-none" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle Menu">
 <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
 </button>
 </div>
 </div>
 </header>

 {/* Navigation */}
 <div className={`bg-[#1b3160] sticky top-[60px] md:top-[80px] z-40 ${menuOpen ? 'block' : 'hidden'} lg:block border-b border-white/10`}>
 <div className="container max-w-full flex justify-center">
 <nav className="relative main-nav">
 {renderMenu(topMenus)}
 </nav>
 </div>
 </div>

 {menuOpen && <div className="fixed inset-0 bg-black/40 z-30" onClick={() => setMenuOpen(false)} />}

 {/* Video Popup Modal */}
 {isVideoOpen && (
 <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4">
 <div className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden shadow-2xl">
 <button 
 onClick={() => setIsVideoOpen(false)}
 className="absolute top-4 right-4 text-white hover:text-gray-300 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50"
 aria-label="Close video"
 >
 <i className="fas fa-times text-xl"></i>
 </button>
 <div className="aspect-video w-full">
 <iframe 
 width="100%" 
 height="100%" 
 src="https://www.youtube.com/embed/tZdSfFY7IcQ?autoplay=1" 
 title="Our Campus Tour" 
 frameBorder="0" 
 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
 allowFullScreen>
 </iframe>
 </div>
 </div>
 </div>
 )}
 </>
 );
};

export default Header;
